var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChevronPinkRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3661 6.61612C10.8543 6.12796 11.6457 6.12796 12.1339 6.61612L19.6339 14.1161C20.122 14.6043 20.122 15.3957 19.6339 15.8839L12.1339 23.3839C11.6457 23.872 10.8543 23.872 10.3661 23.3839C9.87796 22.8957 9.87796 22.1043 10.3661 21.6161L16.9822 15L10.3661 8.38388C9.87796 7.89573 9.87796 7.10427 10.3661 6.61612Z",
    fill: "#ff6eb4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronPinkRight);
export default __webpack_public_path__ + "static/media/icChevronPinkRight.c8f10386e845ce656735e49c8c8bb42f.svg";
export { ForwardRef as ReactComponent };